import type { Offer } from "@types_def/models/offer.types";

export const DriverNameCell = ({ children }: { children?: Pick<Offer, "driver"> }) => {
  const fullName =
    `${children?.driver?.firstName ?? ""} ${children?.driver?.lastName ?? ""}`.trim();
  return fullName || null;
};
